import React from 'react';
import { IFabMenu } from '@app/models';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab/';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { TooltipComponent } from '@app/components/Tooltip';

interface IProps {
    menu: IFabMenu;
    hideTooltip?: boolean;
    tooltipTitle?: string;
    tooltipDescription?: string;
    id?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        speedDial: {
            position: 'fixed',
            '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
                bottom: theme.spacing(3),
                right: theme.spacing(3),
            },
            '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
                top: theme.spacing(3),
                left: theme.spacing(3),
            },
        }, tooltip: {
            position: 'fixed',
            bottom: theme.spacing(3),
            right: theme.spacing(15),
        },
    }),
);

export const FabMenu: React.SFC<IProps> = ({ menu, hideTooltip = true, tooltipTitle, tooltipDescription, id = 'addFab' }) => {
    const classes = useStyles();
    const { translation } = useTypedTranslation();
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <>
            {!hideTooltip &&
                <TooltipComponent classNameForParentDiv={classes.tooltip} title={tooltipTitle || ''} description={tooltipDescription || ''} />
            }

            <SpeedDial
                id={id}
                className={classes.speedDial}
                ariaLabel={translation(menu.name)}
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                icon={<SpeedDialIcon />}
            >
                {menu.actions.map(action => (
                    <SpeedDialAction
                        id={action.name}
                        key={action.name}
                        icon={action.iconElement}
                        tooltipTitle={translation(action.name)}
                        onClick={action.method.bind(action)}
                    />
                ))}
            </SpeedDial>
        </>
    );
};
